module.exports = __webpack_public_path__ + "static/media/COPING_DODGING.333ebc78.md";